import React, { useContext } from 'react';

import { IConstructorGrid } from '@/interfaces/constructor.interfaces';

interface ConstructorContext {
  grid: IConstructorGrid;
}

export const ConstructorContext = React.createContext<ConstructorContext>({
  grid: {
    id: 'root',
    items: [],
  },
});

export function useConstructor() {
  const context = useContext(ConstructorContext);

  if (context === undefined) {
    throw new Error(
      `${useConstructor.name} hook was used outside of ${ConstructorContext.Provider.name}.`,
    );
  }

  return context;
}
